import {
  AUDIO_RECORDING_SESSION_TYPE,
  REGULAR_AI_SESSION_TYPE,
} from "../constants";

export const isAIVideoSession = (appointmentTypeLabel: string) => {
  if (!appointmentTypeLabel) return false;
  return (
    appointmentTypeLabel === REGULAR_AI_SESSION_TYPE ||
    appointmentTypeLabel.includes("AI Video Session")
  );
};

export const isAIAudioSession = (appointmentTypeLabel: string) => {
  if (!appointmentTypeLabel) return false;
  return (
    appointmentTypeLabel === AUDIO_RECORDING_SESSION_TYPE ||
    appointmentTypeLabel.includes("AI Audio Session")
  );
};

export const isAIAudioSessionForAllPlan = (
  appointment: AppointmentMetaData,
  sessionSource?: string,
) => {
  return (
    isAIAudioSession(appointment.appointment_type_label) ||
    appointment.session_recording_source === "live-audio-recording" ||
    appointment.session_recording_source === "upload" ||
    sessionSource === "upload"
  );
};

export const isAIVideoSessionForAllPlan = (
  appointment: AppointmentMetaData,
) => {
  return (
    isAIVideoSession(appointment.appointment_type_label) ||
    !!appointment.orchid_pro_joined_ai_room // EHR plan user
  );
};

export const isAIAudioSessionOnNotesTab = (sessionRecordingSource) => {
  return sessionRecordingSource === "live-audio-recording";
};

export const isAIVideoSessionOnNotesTab = (orchidProJoinedAIRoom) => {
  return !!orchidProJoinedAIRoom;
};

export const isNonAIAppointment = (appointment: AppointmentMetaData) => {
  return (
    !isAIAudioSessionForAllPlan(appointment) &&
    !isAIVideoSessionForAllPlan(appointment)
  );
};
